import React from 'react';

export const Phone = () => (
    <>
        <path d='M11.5,14c-0.276,0-0.5,0.224-0.5,0.5V19H1V9h4.5C5.776,9,6,8.776,6,8.5S5.776,8,5.5,8H1V6.5C1,5.673,1.673,5,2.5,5h3
				C5.776,5,6,4.776,6,4.5S5.776,4,5.5,4h-3C1.122,4,0,5.121,0,6.5v15C0,22.879,1.122,24,2.5,24h7c1.378,0,2.5-1.121,2.5-2.5v-7
				C12,14.224,11.776,14,11.5,14z M9.5,23h-7C1.673,23,1,22.327,1,21.5V20h10v1.5C11,22.327,10.327,23,9.5,23z' />
        <path d='M5.5,6h-1C4.224,6,4,6.224,4,6.5S4.224,7,4.5,7h1C5.776,7,6,6.776,6,6.5S5.776,6,5.5,6z' />
        <path d='M6,20.5c-0.551,0-1,0.448-1,1s0.449,1,1,1s1-0.448,1-1S6.551,20.5,6,20.5z M6,21.5L6,21.5h0.5H6z' />
        <path d='M20.5,1h-10C9.122,1,8,2.121,8,3.5v6c0,1.379,1.122,2.5,2.5,2.5h10c1.378,0,2.5-1.121,2.5-2.5v-6
				C23,2.121,21.878,1,20.5,1z M11.736,11l1.343-2.237l2.285,0.864c0.23,0.084,0.489-0.006,0.611-0.22l2.088-3.657L19.566,11H11.736
				z M22,9.5c0,0.792-0.618,1.436-1.396,1.489l-1.905-6.655c-0.055-0.193-0.221-0.335-0.42-0.358
				c-0.209-0.026-0.396,0.073-0.494,0.248L15.318,8.54l-2.276-0.86c-0.226-0.084-0.48,0.004-0.605,0.211L10.571,11H10.5
				C9.673,11,9,10.327,9,9.5v-6C9,2.673,9.673,2,10.5,2h10C21.327,2,22,2.673,22,3.5V9.5z' />
        <path d='M12.859,3.625c-0.831,0-1.506,0.676-1.506,1.506s0.675,1.506,1.506,1.506s1.506-0.676,1.506-1.506
				S13.69,3.625,12.859,3.625z M12.859,5.637c-0.279,0-0.506-0.227-0.506-0.506s0.227-0.506,0.506-0.506s0.506,0.227,0.506,0.506
				S13.138,5.637,12.859,5.637z' />
    </>
);